import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { INBOUND_PROCESS_STATUS } from 'domains/merchant-inbound/constants'

const propTypes = {
  inboundProcessStatus: PropTypes.string.isRequired
}

/**
 * It maps `inbound process status` to certain style and pass to `StatusBadge`.
 * @param {string} inbound process_status Merchant Inbound process status. available values
 * - `pending`
 * - `ready_live`,
 * - `completed`
 */
const MerchantInboundProcessStatusBadge = ({ inboundProcessStatus }) => {

  const colorMap = {
    [INBOUND_PROCESS_STATUS.PENDING]    : 'warning',
    [INBOUND_PROCESS_STATUS.READY_LIVE] : 'primary',
    [INBOUND_PROCESS_STATUS.COMPLETED]  : 'success'
  }

  const color = colorMap[inboundProcessStatus] || 'default'

  return <StatusBadge color={ color } label={ inboundProcessStatus } />
}

MerchantInboundProcessStatusBadge.propTypes = propTypes

export default MerchantInboundProcessStatusBadge